import AccountPageTemplate from 'components/shared/AccountPageTemplate'

import { FormattedMessage } from 'react-intl'

const AccountActivated = () => (
    <AccountPageTemplate
        title={
            <FormattedMessage
                id="global.registration_account_already_activated"
                defaultMessage="Ups! To konto jest już aktywne."
            />
        }
        text={
            <FormattedMessage
                id="global.registration_message"
                defaultMessage="To konto zostało już aktywowane."
            />
        }
    />
)

export default AccountActivated
